module.exports = __webpack_public_path__ + "static/fonts/manrope-medium.140378ca.woff";